"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Layout3D_1 = require("../Layout3D");
var migrateAutoSizing = function (propertyGroup) {
    migrateAutoSizingForProperty(propertyGroup, 'sizeAbsolute.x');
    migrateAutoSizingForProperty(propertyGroup, 'sizeAbsolute.y');
};
var migrateAutoSizingForProperty = function (propertyGroup, propertyName) {
    if (propertyGroup[propertyName]) {
        for (var keyframeMs in propertyGroup[propertyName]) {
            if (propertyGroup[propertyName][keyframeMs].value === true) {
                propertyGroup[propertyName][keyframeMs].value = Layout3D_1.AUTO_SIZING_TOKEN;
            }
        }
    }
};
exports.default = migrateAutoSizing;
//# sourceMappingURL=migrateAutoSizing.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@haiku/core/lib/helpers/migrateAutoSizing.js
// module id = 129
// module chunks = 35783957827783 127651196306611 162898551421021